import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Snackbar(): Components {
  return {
    MuiSnackbarContent: {
      styleOverrides: {
        root: {}
      }
    }
  };
}
